import { Box, Typography } from "@mui/joy";
import Add from "@mui/icons-material/Add";
import React, { useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import GenericTableView from "../../components/GenericTableView";
import { FilterMatchMode } from "primereact/api";
import { GenericTableColumTypes, GenericTableFilterTypes } from "../../enum/TableView";
import { v4 as uuid } from "uuid";
import { GenericTableColumns } from "../../models/GenericTableViewModel";
import { removeClient } from "../../service/clientService";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { RouteComponentProps } from "../../models/RouteComponent";
import { removeEquipmentList } from "../../service/equipmentListService";
import RiskAssessmentAdd from "./risk-assessment-Add";
import {
  addRiskAssessment,
  getRiskAssessmentReport,
  removeRiskAssessment,
} from "../../service/riskAssessmentService";
import { Grid } from "@mui/material";
import { Button } from "primereact/button";
import { generatePdf } from "../../service/pdfGenerator";

export default function RiskAssessmentView(props: RouteComponentProps) {
  const [selectedType, setTypes] = useState({} as any);
  const [visible, setVisible] = useState(false);
  const [reload, setReload] = useState(false);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [preview, setPreview] = useState("");
  const toast = useRef(null as any);
  const dialog = useRef(null as any);

  const client_id = props?.session?.client_id;
  const site_id = props?.session?.site_id;

  const baseFilter = {
    type: { value: "", matchMode: FilterMatchMode.CONTAINS },
  };

  const deleteButton = (row: any) => {
    console.log("deleteButton row == ", selectedType);
    removeClient(selectedType.id);
  };

  const downloadButton = async (row: any) => {
    props.setGlobalLoader(true);
    const content = await getRiskAssessmentReport();
    setPreview(content);
    setPreviewVisible(true);
    console.log("content == ", content);
    props.setGlobalLoader(false);
  };

  const generatePDF = async (row: any) => {
    const session = props.session;
    props.setGlobalLoader(true);
    await generatePdf(preview, `Task_Based_Risk_Assessment.pdf`);
    props.setGlobalLoader(false);
  };

  const addButton = (row: any) => {
    console.log("addButton row == ", row);
    setTypes(null);
    setVisible(true);
  };

  const itemSelected = (row: any) => {
    console.log("itemSelected row == ", row);
    setTypes(row.value);
    editConfirm(row);
  };

  const contextItemSelected = (row: any) => {
    console.log("contextItemSelected row == ", row);
    setTypes(row.value);
  };

  const acceptFunc = async () => {
    props.setGlobalLoader(true);
    const industry = await removeRiskAssessment(selectedType.id);
    props.setGlobalLoader(false);
    setReload(!reload);
    toast.current.show({ severity: "success", summary: "Risk Deleted Successfully", life: 3000 });
  };

  const editConfirm = (row: any) => {
    setVisible(true);
  };

  const deleteConfirm = (row: any) => {
    confirmDialog({
      message: "Are you sure you want to proceed?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => acceptFunc(),
    });
  };

  const unableToEdit = (row: any) => {
    toast.current.show({ severity: "warning", summary: "Unable To Edit Risk", life: 3000 });
  };

  const duplicate = (row: any) => {
    props.setGlobalLoader(true);
    addRiskAssessment({
      hazard: `${selectedType.hazard} Duplicate`,
      description: selectedType.description,
      responsible: selectedType.responsible,
      likelihood: selectedType.likelihood,
      consequence: selectedType.consequence,
      rating: selectedType.rating,
      control_measures: selectedType.control_measures,
      after_likelihood: selectedType.after_likelihood,
      after_consequence: selectedType.after_consequence,
      after_rating: selectedType.after_rating,
      hazard_id: selectedType.hazard_id,
      note: selectedType.note,
      client_id: client_id,
    })
      .then((r: any) => {
        toast.current.show({
          severity: "success",
          summary: "Risk Created Successfully",
          life: 3000,
        });
        props.setGlobalLoader(false);
        setReload(!reload);
      })
      .catch(err => {
        toast.current.show({ severity: "error", summary: "Failed to Create Risk", life: 3000 });
        props.setGlobalLoader(false);
      });
  };

  const contextItems = () => {
    let objArray: any[] = [];
    if (!site_id) {
      objArray.push({ label: "Duplicate", icon: "pi pi-fw pi-copy", command: duplicate });
      objArray.push({ label: "Edit", icon: "pi pi-fw pi-pencil", command: editConfirm });
      objArray.push({ label: "Delete", icon: "pi pi-fw pi-trash", command: deleteConfirm });
    } else {
      objArray.push({ label: "View", icon: "pi pi-fw pi-eye", command: editConfirm });
    }
    return objArray;
  };

  const columns: GenericTableColumns[] = [
    {
      field: "risk_id",
      header: "Risk ID",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "review_date",
      header: "Review Date",
      type: GenericTableColumTypes.Date,
      visible: true,
      sort: true,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Date,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "hazard_list",
      header: "Hazard",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "description",
      header: "Risk Outcome",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "likelihood_label",
      header: "Before Likelihood",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "consequence_label",
      header: "Before Consequence",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "rating_label",
      header: "Before Rating",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "after_likelihood_label",
      header: "After Likelihood",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "after_consequence_label",
      header: "After Consequence",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
    {
      field: "after_rating_label",
      header: "After Rating",
      type: GenericTableColumTypes.Text,
      visible: true,
      sort: false,
      filter: true,
      filterOption: {
        type: GenericTableFilterTypes.Text,
        options: [
          {
            label: "",
            value: "",
          },
        ],
      },
    },
  ];

  const headerElement = (
    <Grid container spacing={2}>
      <Grid item xs={7}>
        <label>Task Based Risk Assessment</label>
      </Grid>
      <Grid item xs={5}>
        <Button
          type="button"
          icon="pi pi-file-pdf"
          label="Generate PDF"
          className="p-button-outlined"
          size="small"
          style={{ float: "right", fontSize: "small", marginRight: 10, color: "#2dd36f" }}
          onClick={generatePDF}
        />
      </Grid>
    </Grid>
  );

  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          mb: 1,
          gap: 1,
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "start", sm: "center" },
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        <Typography level="h2" component="h1">
          Risks
        </Typography>

        {/* <Button
            color="primary"
            startDecorator={<Add />}
            size="sm"
            onClick={() => setVisible(true)}
          >Add</Button> */}
      </Box>

      <GenericTableView
        reload={reload}
        baseFilters={baseFilter}
        url="risk-assessment"
        columns={columns}
        contextItems={contextItems}
        addButton={site_id ? undefined : addButton}
        downloadButton={client_id ? downloadButton : undefined}
        itemSelect={itemSelected}
        contextItemSelected={contextItemSelected}
      />

      <Dialog
        ref={dialog}
        header={site_id ? "View Risk" : selectedType?.id ? "Update Risk" : "Add Risk"}
        visible={visible}
        style={{ width: "70vw" }}
        onHide={() => setVisible(false)}
      >
        <RiskAssessmentAdd
          setGlobalLoading={props.setGlobalLoader}
          setReload={setReload}
          reload={reload}
          id={selectedType?.id}
          uuid={uuid()}
          details={selectedType}
          setVisible={setVisible}
          toast={toast}
          client={client_id}
          site={site_id}
        />
      </Dialog>

      <Dialog
        header={headerElement}
        visible={previewVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!previewVisible) return;
          setPreviewVisible(false);
        }}
      >
        <div dangerouslySetInnerHTML={{ __html: preview }} />
      </Dialog>

      <ConfirmDialog />

      <Toast ref={toast} />
    </React.Fragment>
  );
}
